import { useQuery } from '@tanstack/react-query';
import { SortKey } from 'src/components/Earn/BorrowLend/BorrowLendTable/types';
import { ExploreSortKey } from 'src/components/Earn/ExploreAndCompare/types';

interface EarnConfigResponse {
	borrow_lend_sortkeys: SortKey[];
	highlighted_market_indices: number[];
	explore_sortkeys: ExploreSortKey[];
	pk: string;
	sk: string;
}

export function useEarnConfig() {
	return useQuery({
		queryKey: ['earnConfig'],
		queryFn: async (): Promise<EarnConfigResponse> => {
			const response = await fetch('/api/earn-config');
			if (!response.ok) {
				throw new Error(`Failed to fetch earn config: ${response.status}`);
			}
			return response.json();
		},
		staleTime: Infinity,
		gcTime: Infinity,
	});
}
